import React from "react";

import styled from "@emotion/styled";

const PhoneIcon = ({ color = "#E1E1E1", hoverColor = color }) => {
    const SVG = styled.svg`
        fill: ${color};

        &:hover {
            fill: ${hoverColor};
        }
    `;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <path
                id="phone-regular-full"
                d="M75.363,72.1a1.812,1.812,0,0,1,2.222.968l1.28,2.815a1.816,1.816,0,0,1-.516,2.164l-.78.622A9.185,9.185,0,0,0,81.259,82.5l.684-.858a1.807,1.807,0,0,1,2.164-.516l2.815,1.28a1.809,1.809,0,0,1,.968,2.222A4.717,4.717,0,0,1,82.7,87.937,12.807,12.807,0,0,1,72.051,77.288,4.722,4.722,0,0,1,75.36,72.1Zm.813,1.609a.263.263,0,0,0-.323-.142,3.173,3.173,0,0,0-2.274,3.451,11.262,11.262,0,0,0,9.391,9.395,3.176,3.176,0,0,0,3.451-2.274.263.263,0,0,0-.142-.323l-2.815-1.284a.263.263,0,0,0-.313.074l-1.08,1.351a.772.772,0,0,1-.935.216A10.717,10.717,0,0,1,75.9,78.749a.772.772,0,0,1,.226-.909l1.255-1a.259.259,0,0,0,.074-.313l-1.28-2.819Z"
                transform="translate(-71.983 -72.006)"
                fill="#05235f"
            />
        </svg>
    );
};

export default PhoneIcon;
